export const ProcessingConsentTypes = {
  IMPLICIT: 'IMPLICIT',
  REQUIRED_CHECKBOX: 'REQUIRED_CHECKBOX'
};
export default ProcessingConsentTypes;